import styled from "styled-components"
import media from "styled-media-query"

export const Wrapper = styled.section`
  align-items: center;
  color: var(--texts);
  display: flex;
  padding: 1.5rem 3rem;
  justify-content: space-between;
  max-width: 400px;
  margin: 0 auto 12px;

  ${media.lessThan("large")`
  font-size: .8rem;
  padding: 1rem;
`}

  a {
    color: var(--texts);
    text-decoration: none;
    transition: color 0.5s;

    svg {
      width: 45px;
      color: #67f3aa;
    }
  }
`

export const Switch = styled.ul`
  display: flex;
  align-items: center;
  justify-content: space-around;
  flex: 3;

  a:nth-child(${props => props.currentPage}) {
    color: #67f3aa;
    font-weight: bold;
  }
`

export const Page = styled.a`
  font-size: 1.3rem;
  line-height: 16px;
  letter-spacing: 0.914285px;
  color: #6b798b;
  cursor: pointer;

  &:hover {
    color: #67f3aa;
    font-weight: bold;
  }
`

export const PaginationLink = styled.a``
